import Vue from 'vue';
import Router from 'vue-router';
import Customer from './views/Layouts/Customer.vue';
import Admin from './views/Layouts/Admin.vue';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import Signup from './views/Signup.vue';
import ForgotPassword from './views/ForgotPassword.vue';
import RestaurantHome from './views/RestaurantHome.vue';
import Restaurants from './views/Restaurants.vue';
import Cart from './views/Cart.vue';
import Order from './views/Order.vue';
import MyOrders from './views/MyOrders.vue';
import Verification from './views/Verification.vue';
import Menu from './views/Admin/Menu.vue';
import TablePlan from './views/Admin/TablePlan.vue';
import Orders from './views/Admin/Orders.vue';
import AdminLogin from './views/Admin/AdminLogin.vue';
import AdminSignup from './views/Admin/AdminSignup.vue';
import Account from './views/Admin/Account.vue';
import store from './store';

Vue.use(Router);

const authGuard = (to, from, next) => {
  if (!store.state.isAuthenticated) {
    next('/admin/login');
  } else {
    next();
  }
};
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      children: [
        {
          path: 'menu',
          name: 'menu',
          component: Menu,
          beforeEnter: authGuard,
        },
        {
          path: 'tables',
          name: 'tableplan',
          component: TablePlan,
          beforeEnter: authGuard,
        },
        {
          path: 'orders',
          name: 'orders',
          component: Orders,
          beforeEnter: authGuard,
        },
        {
          path: 'login',
          name: 'adminlogin',
          component: AdminLogin,
        },
        {
          path: 'signup',
          name: 'adminSignup',
          component: AdminSignup,
        },
        {
          path: 'verification',
          name: 'customer verification',
          component: Verification,
        },
        {
          path: 'account',
          name: 'admin account',
          component: Account,
        },
      ],
    },
    {
      path: '/',
      component: Customer,
      children: [
        {
          path: '',
          name: 'home',
          component: Home,
        },
        {
          path: '/login',
          name: 'login',
          component: Login,
        },
        {
          path: '/signup',
          name: 'signup',
          component: Signup,
        },
        {
          path: '/forgotpassword',
          name: 'forgotpassword',
          component: ForgotPassword,
        },
        {
          path: '/restaurants',
          name: 'Restaurants',
          component: Restaurants,
        },
        {
          path: '/restaurants/:restaurantId',
          name: 'RestaurantHome',
          component: RestaurantHome,
          beforeEnter: authGuard,
        },
        {
          path: '/cart',
          name: 'cart',
          component: Cart,
          beforeEnter: authGuard,
        },
        {
          path: '/myorders',
          name: 'myorders',
          component: MyOrders,
          beforeEnter: authGuard,
        },
        {
          path: '/order/:orderId*',
          name: 'order',
          component: Order,
          beforeEnter: authGuard,
        },
        {
          path: 'verification',
          name: 'verification',
          component: Verification,
        },
      ],
    },
  ],
});
